export default function comprasDTO(data) {
  return {
    DATA_COMPRA: data.dataCompra,
    IDFORNECEDOR: Number(data.idFornecedor),
    valortotal: Number(data.valorTotal),
    IDPAGTO: Number(data.idPagto),
    PAGO: data.pago === true || data.pago === "true",
    DATA_PAGAMENTO: data.dataPagamento || null,
    CANCELADA: data.cancelada === true || data.cancelada === "true",
    OBSERVACOES: data.observacoes || "",

    itens: (data.itens || []).map(i => ({
      IDPRODUTO: Number(i.idProduto),
      QUANTIDADE: Number(i.quantidade),
      valorunitario: Number(i.valorUnitario),
      valortotal: Number(i.valorTotal)
    }))
  };
}